<template>
  <div class="tab-pane active" id="form-step-2">
    <div class="row">
      <div class="col-sm-12">
        <h4 class="info-text ">
          Confirm your requirements
        </h4>
        <p>
          So that we can personalise your service, tell us what currency/country
          you would like to send money to.
        </p>
      </div>
      <div class="col-sm-12">
        <div class="form-group">
          <div class="form-row">
            <div class="col">
              <label class="form-label required">Source currency</label>
              <vue-select
                class="vue-select"
                name="sourceCurrency"
                :options="currencies"
                :class="{ error: errors.has('step2.sourceCurrency') }"
                label="CurrencyName"
                v-model="sourceCurrency"
                data-vv-scope="step2"
                v-validate="'required'"
                autocomplete="none"
              >
                <template slot="selected-option" slot-scope="option">
                  <div class="flex">
                    <div class="long-and-truncated-with-child-corrected">
                      <span>{{ option.CurrencyCode }}</span>
                    </div>
                  </div>
                </template>
                <template slot="option" slot-scope="option">
                  {{ option.CurrencyName }}
                </template>
              </vue-select>
            </div>
            <div class="col">
              <label class="form-label required">Target currency</label>
              <vue-select
                class="vue-select"
                name="targetCurrency"
                :options="currencies"
                :class="{ error: errors.has('step2.targetCurrency') }"
                label="CurrencyName"
                v-model="targetCurrency"
                data-vv-scope="step2"
                v-validate="'required'"
                autocomplete="none"
              >
                <template slot="selected-option" slot-scope="option">
                  <div class="flex">
                    <div class="long-and-truncated-with-child-corrected">
                      <span>{{ option.CurrencyCode }}</span>
                    </div>
                  </div>
                </template>
                <template slot="option" slot-scope="option">
                  {{ option.CurrencyName }}
                </template>
              </vue-select>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-12">
        <div class="form-group">
          <label class="form-label required">Amount</label>
          <input
            name="transferAmount"
            type="number"
            class="form-control"
            :class="{ error: errors.has('step2.transferAmount') }"
            placeholder="Amount"
            v-model.trim="transferAmount"
            data-vv-scope="step2"
            v-validate="'required|min_value:1'"
          />
        </div>
      </div>
      <div class="col-sm-12">
        <div class="form-group">
          <label class="form-label required">Transfer destination</label>

          <vue-select
            class="vue-select"
            name="transferDestination"
            :options="countries"
            :class="{ error: errors.has('step2.transferDestination') }"
            label="CountryName"
            v-model="transferDestination"
            data-vv-scope="step2"
            v-validate="'required'"
            autocomplete="none"
          >
            <template slot="selected-option" slot-scope="option">
              <div class="flex">
                <div class="long-and-truncated-with-child-corrected">
                  <span>{{ option.CountryName }}</span>
                </div>
              </div>
            </template>
            <template slot="option" slot-scope="option">
              <span
                class="flag-icon flag-icon-squared"
                :class="('flag-icon-' + option.TwoCharCode) | lowerCase"
              ></span
              >&nbsp;
              {{ option.CountryName }}
            </template>
          </vue-select>
        </div>
      </div>
      <div class="col-sm-12">
        <div class="form-group">
          <label class="form-label required">Reasons for transfer</label>
          <select
            name="reasonForTransfer"
            class="form-control custom-select"
            required
            v-model.trim="reasonForTransfer"
            :class="{ error: errors.has('step2.reasonForTransfer') }"
            data-vv-scope="step2"
            v-validate="'required'"
          >
            <option
              :value="rft.CodesId"
              v-for="(rft, index) in rfts"
              :key="index"
              >{{ rft.SelectionValue }}</option
            >
          </select>
        </div>
      </div>
      <div class="col-sm-12" >
        <div class="form-group">
          <label class="form-label required">How did you hear about us</label>
          <select
            name="referralSource"
            class="form-control custom-select"
            v-model.trim="referralSource"
            :class="{ error: errors.has('step2.referralSource') }"
            data-vv-scope="step2"
            v-validate="'required'"
          >
            <option value="">Select...</option>
            <option value="44">Employee</option>
            <option value="43">Recommended by a friend</option>
            <option value="39">Google</option>
            <option value="40">Webinars and Shows</option>
            <option value="2004">Social Networking</option>
            <option value="2898">AI Search</option>
            <option value="223">Others</option>
          </select>
        </div>
      </div>
      <div class="col-sm-12" v-if="recommnededByFriend">
        <div class="form-group">
          <label class="form-label">Please provide their email to start earning £50 referral rewards!</label>
           <input
            name="referredByEmail"
            type="email"
            class="form-control"
            :class="{ error: errors.has('step2.referredByEmail') }"
            placeholder="Email Address"
            v-model.trim="referredByEmail"
            data-vv-scope="step2"
            v-validate="recommnededByFriend ? 'required|email' :''"
          />
        </div>
      </div>

            <Loading v-if="loading" />
    </div>
  </div>
</template>
<script>
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { mapFields } from "vuex-map-fields";
import { mapGetters } from "vuex";
import mixin from "@/components/shared/mixinUtility";
import Loading from "@/components/ui/Loading.vue";
export default {
  name: "Preference",
  mixins: [mixin],
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ...mapFields([
      "form.sourceCurrency",
      "form.targetCurrency",
      "form.transferAmount",
      "form.transferDestination",
      "form.reasonForTransfer",
      "form.referralSource",
      "form.referredByEmail",
    ]),
    ...mapGetters({
      currentActive: "getCurrentActive",
      formData: "getFormData",
      actions: "getActions",
      currencies: "getCurrencies",
      countries: "getCountries",
      rfts: "getRfts",
      contactId: "getContactId",
      jwtToken:"getJwtToken"
    }),
    recommnededByFriend() {
      return this.formData.referralSource == "43";
    },
  },
  components: {
    "vue-select": VueSelect,
    Loading,
  },
  created() {
    //letting selected by user
    this.formData.referralSource="";
  },  
};
</script>
